window.getStepCount = (startStep, endStep, steps) => {
    let count = 0
    if (startStep.position) {
        count++;
    }

    if (endStep.position) {
        count++;
    }

    count = count + steps.length;

    return count.toString();
}

window.getRoadtripTemplate = (roadtrip) => {
    return `
        <div class="roadtrips-element"
            data-roadtrip-id="${roadtrip.id}"
            data-roadtrip="${JSON.stringify(roadtrip)}"
        >
            <div class="img-container">
                <img src="${roadtrip.image?.length > 0
                    ? roadtrip.image
                    : '/wp-content/themes/lostintheusa/dist/images/default-roadtrip-thumb.jpg'}"
                    class="roadtrips-image"
                    alt="Image de mon roadtrip"
                />
            </div>
            <div class="text-container">
                <div class="title">
                     ${roadtrip.name}
                </div>
                <div class="info">
                    ${window.getStepCount(roadtrip.data.startStep, roadtrip.data.endStep, roadtrip.data.steps)} étape(s) ${roadtrip.data.distance ? ', ' + roadtrip.data.distance +' km' : ''}
                </div>
            </div>
        </div>
    `;   
}